<script setup>
import {ref, defineProps, onMounted} from 'vue';
import mitt from 'mitt';

const emitter = mitt();
const isModalOpen = ref(false);

//const props = defineProps(['content', 'other']);
const props = defineProps([
    'content'
])

onMounted(() => {
    let smallModal = document.querySelector('.small-modal');
    if (smallModal) {
        let modalWrapper = smallModal.closest('.c-modal__wrapper');
        if (modalWrapper) {
            modalWrapper.style.maxWidth = '450px';
        }
    }
});

</script>

<template>
    <div class="small-modal">
        <p v-html="content"></p>
    </div>
</template>

<style>
/* Add any necessary styles for your modal here */
</style>
